@if (visible()) {
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
  <div class="rou-backdrop" (click)="close()">
    <div
      class="rou-dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="rou-title"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
      (click)="$event.stopPropagation()"
      (keydown.escape)="close()"
    >
      <to-section-title
        headingId="rou-title"
        [title]="'testResults.upload.title' | translate"
        [subtitle]="'testResults.upload.subtitle' | translate"
      >
        <button
          right
          type="button"
          class="rou-header__close"
          [attr.aria-label]="'testResults.upload.close' | translate"
          (click)="close()"
        >
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
      </to-section-title>

      <div class="rou-body">
        @if (errorMessage(); as message) {
          <p class="rou-error" role="alert">{{ message }}</p>
        }

        @if (result(); as r) {
          <div class="rou-report">
            <span class="rou-report__icon" aria-hidden="true">
              <mat-icon>check_circle</mat-icon>
            </span>
            <h3 class="rou-report__title">{{ 'testResults.upload.success' | translate }}</h3>
            <p class="rou-report__summary">
              {{ 'testResults.upload.imported' | translate: { count: r.importedTests } }}
            </p>
            @if (r.skipped.length > 0) {
              <div class="rou-skipped">
                <div class="rou-skipped__title">{{ 'testResults.upload.skippedTitle' | translate }}</div>
                <p class="rou-skipped__hint">{{ 'testResults.upload.skippedHint' | translate }}</p>
                <ul class="rou-skipped__list">
                  @for (skipped of r.skipped; track $index) {
                    <li class="rou-skipped__item">
                      <span class="rou-skipped__name">{{ skipped.testName }}</span>
                      @if (skipReason(skipped); as reason) {
                        <span class="sr-only">:&#32;</span>
                        <span class="rou-skipped__reason">{{ reason }}</span>
                      }
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
        } @else {
          <app-file-dropzone
            [accept]="acceptedFileTypes"
            [hint]="'testResults.upload.dropHint' | translate"
            (fileSelected)="onFileSelected($event)"
            (cleared)="onFileCleared()"
          />
        }
      </div>

      <div class="rou-footer">
        @if (result()) {
          <button type="button" class="rou-btn rou-btn--primary" (click)="close()">
            {{ 'testResults.upload.done' | translate }}
          </button>
        } @else {
          <button type="button" class="rou-btn rou-btn--secondary" (click)="close()">
            {{ 'testResults.upload.cancel' | translate }}
          </button>
          <button
            type="button"
            class="rou-btn rou-btn--primary"
            [disabled]="file() === null || busy()"
            (click)="upload()"
          >
            @if (busy()) {
              <mat-spinner diameter="16" />
              {{ 'testResults.upload.importing' | translate }}
            } @else {
              <mat-icon aria-hidden="true">upload</mat-icon>
              {{ 'testResults.upload.action' | translate }}
            }
          </button>
        }
      </div>
    </div>
  </div>
}
